<template lang="pug"></template>

<script>
export default {
    name: 'BotaoCertificacao',
    componentOptions: {
        title: 'Certificacao',
        actions: [
            [
                {
                    name: 'Certificacao',
                    iconClass: 'lyra-icon lyra-certificacao',
                    showView: false,
                    action: 'abrirCertificacao',
                    route: 'Certificacao'
                }
            ]
        ]
    },

    methods: {
        abrirCertificacao() {
            if (this.$route.name !== 'Certificacao') {
                this.$router.push({ name: 'Certificacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
